import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

const routes: Routes = [
  // {
  //   path : '',
  //   component : AppComponent
  // },
  { path: '', redirectTo: 'plcing-order', pathMatch: 'full' },
  // {
  //   path: 'calender',
  //   loadChildren: () =>
  //     import('./calender/calender.module').then((m) => m.CalenderModule),
  // },
  {
    path: 'login-page',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginModule),
  },
  // {
  //   path: 'change-password',
  //   loadChildren: () =>
  //     import('./change-password/change-password.module').then(
  //       (m) => m.ChangePasswordModule
  //     ),
  // },
  {
    path: 'Register',
    loadChildren: () =>
      import('./register/register.module').then((m) => m.RegisterModule),
  },
  {
    path: 'plcing-order',
    loadChildren: () =>
      import('./plcing-order/plcing-order.module').then((m) => m.PlcingOrderModule),
  },
  {
    path: 'confirm-order/:id',
    loadChildren: () =>
      import('./confirm-order/confirm-order.module').then((m) => m.ConfirmOrderModule),
  },
  // {
  //   path: 'admin',
  //   loadChildren: () =>
  //     import('./admin/admin.module').then((m) => m.AdminModule),
  // },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
